import React from "react";
import { useParams, useSearchParams } from "react-router-dom";
import { Box } from "@mui/material";

import { PageLayout } from "../../layouts/PageLayout";
import { PageHeader } from "../../components/v3";
import { AddEditContractForm } from "../../components/subcontractor";

export const AddEditContract = () => {
  const [searchParams] = useSearchParams();
  const { id } = useParams();
  const subcontractorId = searchParams.get("subcontractorId");

  return (
    <PageLayout>
      {/* header section */}
      <Box sx={{ position: "relative", zIndex: 1 }}>
        <PageHeader
          // title
          title={id ? "Edit Contract" : "Add Contract"}
        />
      </Box>

      {/* add contract form */}
      <Box sx={{ mt: -9, zIndex: 2, position: "relative" }}>
        <AddEditContractForm subcontractorId={subcontractorId} contractId={id} />
      </Box>
    </PageLayout>
  );
};
